import { tv, type VariantProps } from '@workspace/lib';

// Core card styling shared across all card implementations (CardGrid, ApplicationItem, ProductTypeCard, etc.)
export const cardVariants = tv({
  slots: {
    base: 'group relative flex flex-col min-w-0',
    media: 'relative overflow-hidden',
    image: 'size-full object-cover',
    header: 'flex flex-col',
    title: 'min-w-0 font-heading',
    description: 'font-body',
    content: 'flex flex-col',
    footer: 'flex items-center',
    action: 'relative z-10',
  },
});

export type CardVariants = VariantProps<typeof cardVariants>;
